/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { API_CONFIG, getEnv } from '../config/api'
import { ApiResponse, ErrorData } from '../interfaces'
import { ILogin } from '../redux/login'

const env = getEnv()

const {
  sendTo: { url: sendToURL, token },
} = API_CONFIG[env]

const sendLoginFromMiddleware = async (
  type: 'simple' | 'social',
  socialToken?: string,
  username?: string,
  password?: string,
  recaptchaCode?: string,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<ILogin | ErrorData>> => {
  const payload = {
    type,
    socialToken,
    username: username?.replace(/[-./]/g, ''),
    password,
    recaptchaCode,
  }

  try {
    const { data, status } = (await axios({
      ...middleware,
      data: payload,
    })) as AxiosResponse<ILogin>

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>

    if (response) {
      const { data, status } = response

      return {
        data,
        status,
        success: false,
      }
    }

    return {
      data: {
        message: 'login request failed',
        details: {},
      },
      status: 504,
      success: false,
    }
  }
}

const sendToFromBSNG = async (
  type: 'simple' | 'social',
  socialToken?: string,
  username?: string,
  password?: string,
  recaptchaCode?: string
): Promise<ApiResponse<ILogin | ErrorData>> => {
  const payload = {
    type,
    socialToken,
    username: username?.replace(/[-./]/g, ''),
    password,
    recaptchaCode,
  }

  try {
    const { data, status } = await axios.post<ILogin>(sendToURL, payload, {
      headers: {
        'x-api-key': token,
      },
    })

    return {
      data,
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const sendLogin = async (
  type: 'simple' | 'social',
  socialToken?: string,
  username?: string,
  password?: string,
  recaptchaCode?: string,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<ILogin | ErrorData>> => {
  if (middleware) {
    const response = await sendLoginFromMiddleware(type, socialToken, username, password, recaptchaCode, middleware)
    return response
  }

  const response = await sendToFromBSNG(type, socialToken, username, password, recaptchaCode)
  return response
}

export default sendLogin
